// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2727":"00647184255b3249","6242":"86481dbb4ec3dce2","7360":"e33167a233124270","9579":"64d82e69a4afa69b"}[chunkId] + ".css";
};